import {
  UseMutationResult,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
interface NotifyFine {
  fineId: string;
}
const officerNotifyFine = async (data: NotifyFine) => {
  const response = await axiosInstance.post(`fine/${data.fineId}/notify`);
  return response.data;
};

const useOfficerNotifyFine = (): UseMutationResult<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Error,
  NotifyFine
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: officerNotifyFine,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fine'] });
      queryClient.invalidateQueries({ queryKey: ['fines'] });
      queryClient.invalidateQueries({ queryKey: ['officer-pending-cases'] });
      queryClient.invalidateQueries({
        queryKey: ['case-checker-pending-cases'],
      });
    },
    onError: (error: Error) => {
      console.error('Error adding fine:', error.message);
    },
  });
};

export default useOfficerNotifyFine;
